<template>
  <div class="spinner">
    Loading...
  </div>
</template>

<script>
import auth from '@/services/AuthService'
export default {
  name: 'callback',
  data () {
    return {
      auth
    }
  },
  created () {
    this.auth.handleAuthentication()
  }
}
</script>

<style lang="scss" scoped>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
